// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2bc2u","options":"AnswerScale_options__3GDOe","selected":"AnswerScale_selected__2_yuK"};